export const environment = {
  production: true,
  taxesAndFeesURL: "https://gw.easydo.co/qa/api/v1/taxes-fees"
};
